import React from 'react';

import styles from './Success.module.css';

export const Success = () => {
  return (
    <svg
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:svg="http://www.w3.org/2000/svg"
      className={styles.am_Success_Icon}
    >
      <path
        className={styles.am_SVG_circle}
        d="m443.0136,114.07007a236.95276,236.95276 0 0 1 44.1553,137.73747c0,129.97005 -106.94772,236.96443 -236.91777,236.96443s-236.91777,-106.94772 -236.91777,-236.91777s106.94772,-236.96443 236.91777,-236.96443a236.99941,236.99941 0 0 1 168.72548,70.59483"
      />
      <polyline
        className={styles.am_SVG_check}
        points="104.4892349243164,309.2001647949219 195.57406616210938,402.9600524902344 418.9292297363281,85.03718566894531 "
      />
    </svg>
  );
};
